import {
    AssignmentSession,
    HelpfulnessEnum,
    AssignmentMethodEnum,
    Language,
    AssignmentSettings,
    AssignmentRubric,
} from "@knowt/syncing/graphql/schema";

export type AssignmentSessionGroupedByUser = Record<string, AssignmentSession[]>;

export const DEFAULT_ASSIGNMENT_RUBRIC_INPUT: AssignmentRubric = {
    A: {
        score: 100,
        condition: "",
    },
    B: {
        score: 90,
        condition: "",
    },
    C: {
        score: 70,
        condition: "",
    },
    D: {
        score: 60,
        condition: "",
    },
    F: {
        score: 0,
        condition: "",
    },
};

export const DEFAULT_ASSIGNMENT_SETTINGS_INPUT: AssignmentSettings = {
    language: Language.ENGLISH,
    inputMethods: [AssignmentMethodEnum.TEXT],
    outputMethods: [AssignmentMethodEnum.TEXT],
    autoGrade: true,
    grade: "9th",
    timeLimit: 600,
    maxSubmissions: 1,
    rubric: DEFAULT_ASSIGNMENT_RUBRIC_INPUT,
    initialPrompt: "",
    priorKnowledge: [],
    rules: [],
    suggestions: [],
    helpfulness: HelpfulnessEnum.NONE,
};
